export const emptyValueMarker = "EMPTY_VALUE_STRING_WORD";
